const SvgCloseCircleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="M10 18.833c4.583 0 8.333-3.75 8.333-8.333S14.583 2.167 10 2.167 1.667 5.917 1.667 10.5s3.75 8.333 8.333 8.333M7.642 12.858l4.716-4.716M12.358 12.858 7.642 8.142" />
    </g>
  </svg>
);
export default SvgCloseCircleIcon;
